import React from "react";
import SectionHeader, { SectionWrapper, Reveal } from "./SectionHeader";
import { Clock, Library, Rocket, HeartHandshake, Infinity as InfinityIcon } from "lucide-react";

const MOATS = [
  { icon: Clock, title: "11+ Year Time Moat", body: "A decade of compounded trust and audience memory — unbuyable.", color: "#00F0FF", tid: "why-time" },
  { icon: Library, title: "Massive Content Library", body: "45,000+ posts, 450+ videos, 1B+ views — owned IP at scale.", color: "#FF00FF", tid: "why-library" },
  { icon: Rocket, title: "Proven Virality Engine", body: "Replicable moment engineering across platforms and formats.", color: "#FFDE00", tid: "why-virality" },
  { icon: HeartHandshake, title: "Deep Youth Connect", body: "A native voice, not a broadcaster. Trust that survives cycles.", color: "#00F0FF", tid: "why-youth" },
  { icon: InfinityIcon, title: "Unreplicable Scale", body: "500+ macro, 50,000+ micro creators — a private distribution grid.", color: "#FF00FF", tid: "why-scale" },
];

const WhyUth = () => {
  return (
    <SectionWrapper id="why">
      <SectionHeader
        code="// CH.09 — MOATS"
        title="The Moat"
        kicker="The unassailable moats defining our market dominance."
        tid="why"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {MOATS.map((m, i) => {
          const Icon = m.icon;
          const featured = i === 0;
          return (
            <Reveal key={m.tid} delay={i * 0.05}>
              <div
                className={`glass-card hud-corners p-7 md:p-8 h-full relative overflow-hidden ${featured ? "lg:col-span-1" : ""}`}
                data-testid={m.tid}
              >
                <span className="hud-tr" />
                <span className="hud-bl" />
                <div className="flex items-center justify-between mb-6">
                  <div
                    className="w-11 h-11 flex items-center justify-center border flex-none"
                    style={{
                      borderColor: `${m.color}55`,
                      color: m.color,
                      boxShadow: `0 0 14px ${m.color}22`,
                    }}
                  >
                    <Icon size={18} strokeWidth={1.4} />
                  </div>
                  <span className="micro-label" style={{ color: m.color }}>
                    MOAT · {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="font-display font-bold uppercase text-lg md:text-xl tracking-tight leading-snug interactive-text interactive-text--white">
                  {m.title}
                </div>
                <p className="text-white/60 mt-3 text-sm md:text-base leading-relaxed">
                  {m.body}
                </p>

                <div className="section-divider mt-6 opacity-60" />
              </div>
            </Reveal>
          );
        })}
      </div>
    </SectionWrapper>
  );
};

export default WhyUth;
